export const fields = [
	{
		key: "supplierName",
		label: "Proveedor",
		sortable: true
	},
	{
		key: "product",
		label: "Producto del proveedor"
	},
	{
		key: "prices.totalService",
		label: "Costo serv.",
		sortable: true
	},
	{
		key: "prices.costSuppliers",
		label: "Costo prov.",
		sortable: true
	},
	{
		key: "prices.revenue",
		label: "Ganancia",
		sortable: true
	},
	{
		key: "selected",
		label: "Acciones"
	}
];
export const fieldsException = [
	{
		key: "serviceNumber",
		label: "Servicio"
	},
	{
		key: 'message',
		label: 'Mensaje'
	}
]
export const fieldsGlobal = [
	{
		key: "supplierName",
		label: "Proveedor",
	},
	{
		key: "product",
		label: "Producto del proveedor"
	},
	{
		key: "totalService",
		label: "Costo serv.",
	},
	{
		key: "costSuppliers",
		label: "Costo prov.",
	},
	{
		key: "revenue",
		label: "Ganancia",
	},
	{
		key: "selected",
		label: "Acciones"
	}
];

export const items = [
	{
		supplierName: "",
		product: "",
		totalService: "",
		costSuppliers: "",
		revenue: "",
		selected: ""
	}
];
